import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAuthSlice } from '../types';

export const initialState: IAuthSlice = {
  authAddress: undefined,
  authProvider: undefined,
  authToken: undefined,
  authTokenExpiresAt: undefined,
  callback: {
    redirectURL: undefined,
    timestamp: 0,
  },
  isAPIAuthorized: false,
  isMarketingAccepted: false,
  isSignedIn: false,
  isSignedOutManually: false,
  referralCode: undefined,
  walletId: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthAddress: (
      state,
      action: PayloadAction<IAuthSlice['authAddress']>,
    ) => {
      state.authAddress = action.payload;
    },
    setAuthProvider: (
      state,
      action: PayloadAction<IAuthSlice['authProvider']>,
    ) => {
      state.authProvider = action.payload;
    },
    setAuthToken: (state, action: PayloadAction<IAuthSlice['authToken']>) => {
      state.authToken = action.payload;
    },
    setAuthTokenExpiresAt: (
      state,
      action: PayloadAction<IAuthSlice['authTokenExpiresAt']>,
    ) => {
      state.authTokenExpiresAt = action.payload;
    },
    setIsAPIAuthorized: (state, action: PayloadAction<boolean>) => {
      state.isAPIAuthorized = action.payload;
    },
    setIsMarketingAccepted: (
      state,
      action: PayloadAction<IAuthSlice['isMarketingAccepted']>,
    ) => {
      state.isMarketingAccepted = action.payload;
    },
    setIsSignedIn: (state: IAuthSlice, action: PayloadAction<boolean>) => {
      state.isSignedIn = action.payload;
    },
    setIsSignedOutManually: (
      state: IAuthSlice,
      action: PayloadAction<boolean>,
    ) => {
      state.isSignedOutManually = action.payload;
    },
    setRedirectURL: (state, action: PayloadAction<string>) => {
      state.callback = {
        redirectURL: action.payload,
        timestamp: Date.now(),
      };
    },
    setReferralCode: (
      state,
      action: PayloadAction<IAuthSlice['referralCode']>,
    ) => {
      state.referralCode = action.payload;
    },
    setWalletId: (state, action: PayloadAction<IAuthSlice['walletId']>) => {
      state.walletId = action.payload;
    },
    resetAuthSlice: state => ({
      ...initialState,
      callback: state.callback,
      isSignedOutManually: state.isSignedOutManually,
    }),
    resetRedirectURL: state => {
      state.callback = initialState.callback;
    },
    resetIsSignedOutManually: state => {
      state.isSignedOutManually = initialState.isSignedOutManually;
    },
  },
});

export const {
  resetAuthSlice,
  resetIsSignedOutManually,
  resetRedirectURL,
  setAuthAddress,
  setAuthProvider,
  setAuthToken,
  setAuthTokenExpiresAt,
  setIsAPIAuthorized,
  setIsMarketingAccepted,
  setIsSignedIn,
  setIsSignedOutManually,
  setRedirectURL,
  setReferralCode,
  setWalletId,
} = authSlice.actions;
